import { EUnitRole } from '../../interfaces/models/units.interfaces'
import { UnitRole } from '../../types/unit-roles'
import { translateEnumDict } from './helpers'

const unitRoleTranslations: { [key: string]: string } = {
  [UnitRole.MEMBER]: 'unitRoles.member',
  [UnitRole.RESIDENT]: 'unitRoles.resident',
  [UnitRole.TENANT]: 'unitRoles.tentant',
  [UnitRole.RELATIVE]: 'unitRoles.relative',
  [UnitRole.PROPERTY_MANAGER]: 'unitRoles.propertyManager',
  [UnitRole.CUSTOMER_REPRESENTATIVE]: 'unitRoles.customerRepresentative',
  [UnitRole.OTHER]: 'unitRoles.other',
}
type Role =
  | ''
  | 'member'
  | 'resident'
  | 'tenant'
  | 'relative'
  | 'propertymanager'
  | 'customer-rep'
  | 'other'

export const getUnitRole = (
  unitRole: EUnitRole | UnitRole | Role
): string | null => {
  return translateEnumDict(unitRoleTranslations, unitRole)
}
